<script setup>
import dataBlock from "./components/dataBlock.vue";
import trendChart from "./components/trendChart.vue";
import proportionChart from "./components/proportionChart.vue";
import barChart from "./components/barChart.vue";
import { onMounted, ref } from "vue";

const result = ref({});

onMounted(() => {});
</script>

<template>
  <zh-table-page v-bind="{ title: '数据统计' }">
    <template #header-btn></template>
    <template #search></template>
    <template #table>
      <div class="gd">
        <dataBlock />
      </div>
      <div class="flex">
        <trendChart :trend="result" />
        <proportionChart />
      </div>
      <barChart class="mt10" />
    </template>
  </zh-table-page>
</template>

<style scoped>
.gd {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 0px;
}
.flex {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 0px;
}
.mt10 {
  margin-top: 10px;
}
</style>
